export default "__VITE_ASSET__C7YsK52W__"